var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.688 18.544l6.849 7.146 10.72-10.72",
    stroke: "#5700FF",
    strokeWidth: 3.992
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.034 1.996h28.568a7.364 7.364 0 017.364 7.364v28.568H9.398a7.364 7.364 0 01-7.364-7.364V1.996z",
    stroke: "#5700FF",
    strokeWidth: 3.992
  })));
}
export default SvgCheckLabel;